export function Carregando() {
  return (
    <div className="flex min-h-full items-center justify-center bg-background" aria-busy="true">
      <span className="sr-only">Carregando</span>
      <div className="size-6 animate-spin rounded-full border-2 border-border border-t-primary" />
    </div>
  );
}
